const INFO = {
  main: {
    title: "Java Fullstack Developer @ Capgmini Invent",
    name: "Eden Jia",
    email: "edenjia@hotmail.com",
    helmet:
      "Eden Jia's personal portfolio with links to her CV, GitHub and LinkedIn profile.",
  },
  socials: {
    github: "https://github.com/H0PP3R",
    linkedin: "https://www.linkedin.com/in/eden-jia-a13a4b179/",
  },
  cv: {
    downloadLink: "/CV.pdf",
    fileName: "EdenJia_CV.pdf",
  },
};

export default INFO;
